import NightSky from "./NightSky";

export default function WaterBackground() {
  // Small helper — render N shooting stars at staggered positions/delays
  const stars = Array.from({ length: 12 });
  return (
    <div className="stars-bg" aria-hidden="true">
      <div className="stars-glow" />
      {stars.map((_, i) => (
        <span
          key={i}
          className="shooting-star"
          style={{
            top: `${(i * 7 + 6) % 90}%`,
            left: `${(i * 11 + 3) % 90}%`,
            animationDelay: `${i * 2.3}s`,
            animationDuration: `${8 + (i % 5)}s`,
          }}
        />
      ))}
      {/* Twinkling stars + tonight's real moon phase — visible only in dark theme via CSS */}
      <NightSky />
    </div>
  );
}
